import React, { useState } from "react";
import { Link } from "react-router-dom";
import { currencyDisplay } from "../../../../utils/helpers";
import { pricingPaxCount } from "./ChooseYourTour";
import { usePriceQuote } from "../usePriceQuote";
import CompulsoryChargesModal from "./CompulsoryChargesModal";
import { PriceCardProps } from "./GroundTourSidebar";

const ICONS = "/iceholidays-assets/images/icons";

const barMoney = (value: number) => {
  const formatted = currencyDisplay("MYR", value);
  return Number.isInteger(Number(value)) ? formatted.replace(/\.00$/, "") : formatted;
};

export default function GroundTourPriceBar({
  landTourId,
  selectedCategory,
  priceWindow,
  selectedDate,
  paxCounts,
  compulsoryCharges = [],
  complete,
  total,
  contactHref,
  bookingCtaLabel,
  onBookingCta,
  onShowBreakdown,
}: PriceCardProps) {
  const [showCompulsory, setShowCompulsory] = useState(false);

  const { quote } = usePriceQuote({
    landTourId,
    category: selectedCategory,
    date: selectedDate?.date,
    priceDate: priceWindow,
    quantity: pricingPaxCount(paxCounts),
  });

  const hasCharges = compulsoryCharges.length > 0;
  const showTotal = complete && total !== undefined;

  const hasSaving = !!quote && quote.saveAmount > 0;
  const PriceBlock = showTotal || hasCharges ? "button" : "div";
  const onPriceClick = showTotal ? onShowBreakdown : () => setShowCompulsory(true);

  return (
    <div className="ground-tour-show-v2__price-bar">
      {showTotal ? (
        <PriceBlock
          className="ground-tour-show-v2__price-bar-price"
          {...{ type: "button" as const, onClick: onPriceClick, "aria-label": "View price breakdown" }}
        >
          <span className="ground-tour-show-v2__price-bar-was">
            <span className="ground-tour-show-v2__price-bar-from">Total</span>
          </span>

          <span className="ground-tour-show-v2__price-bar-now">
            <span className="ground-tour-show-v2__price-bar-amount">{barMoney(total as number)}</span>
            <img src={`${ICONS}/icon-price-bar-chevron.svg`} alt="" aria-hidden="true" />
          </span>
        </PriceBlock>
      ) : quote ? (
        <PriceBlock
          className="ground-tour-show-v2__price-bar-price"
          {...(hasCharges ? { type: "button" as const, onClick: onPriceClick, "aria-label": "View compulsory charges" } : {})}
        >
          <span className="ground-tour-show-v2__price-bar-was">
            <span className="ground-tour-show-v2__price-bar-from">
              From
              {hasSaving && (
                <span className="ground-tour-show-v2__price-bar-strike">{barMoney(quote.beforeSaveAmount)}</span>
              )}
            </span>

            {hasSaving && (
              <span className="ground-tour-show-v2__price-bar-save">Save {barMoney(quote.saveAmount)}</span>
            )}
          </span>

          <span className="ground-tour-show-v2__price-bar-now">
            <span className="ground-tour-show-v2__price-bar-amount">{barMoney(quote.price)}</span>
            <span className="ground-tour-show-v2__price-bar-suffix">/ person</span>
            {hasCharges && <img src={`${ICONS}/icon-price-bar-chevron.svg`} alt="" aria-hidden="true" />}
          </span>
        </PriceBlock>
      ) : (
        <span />
      )}

      <div className="ground-tour-show-v2__price-bar-actions">
        <Link to={contactHref} className="ground-tour-show-v2__price-bar-contact" aria-label="Contact Us">
          <img src={`${ICONS}/icon-contact-us-red.svg`} alt="" aria-hidden="true" />
          Contact Us
        </Link>

        <button type="button" className="ground-tour-show-v2__price-bar-cta" onClick={onBookingCta}>
          {bookingCtaLabel}
        </button>
      </div>

      {hasCharges && (
        <CompulsoryChargesModal open={showCompulsory} onClose={() => setShowCompulsory(false)} charges={compulsoryCharges} />
      )}
    </div>
  );
}
